import { APP_ENV } from 'config/app';

const isProduction = (): boolean =>
  !['local', 'test', 'stage'].includes(APP_ENV);

export default isProduction;
